import type {
  UserPrivateProfile,
  UserPublicProfile,
} from "@/pages/profile/api";
import { profileIdentityChips } from "@/pages/profile/formatters";
import { useI18n } from "@/shared/i18n/LanguageContext";

type ProfileIdentityChipsProps = {
  profile: UserPublicProfile | UserPrivateProfile;
};

export function ProfileIdentityChips({ profile }: ProfileIdentityChipsProps) {
  const { copy } = useI18n();
  const chips = profileIdentityChips(profile);

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className="profile-chip-row" aria-label={copy.profile.credentialsLabel}>
      {chips.map((chip) => (
        <span key={chip} className="profile-chip">
          {chip}
        </span>
      ))}
    </div>
  );
}
